module.exports = __webpack_public_path__ + "static/img/2.806cd0f7.png";